'use client';

import { useState } from 'react';
import {
  useActiveNavigationItem,
  useSiteConfig,
} from 'modules/shop/siteConfig/hooks';
import { NavigationItem } from './NavigationItem';
import { SearchNavigation } from './SearchNavigation';
import styles from './styles.module.css';

export const SidebarNavigation = () => {
  const { header } = useSiteConfig();

  const activeItem = useActiveNavigationItem(header);

  const [expandedAccordion, setExpandedAccordion] = useState<string | null>(
    null,
  );

  const handleAccordionChange = (id: string) => {
    setExpandedAccordion((prevState) => (prevState === id ? null : id));
  };

  return (
    <div className={styles.root}>
      <SearchNavigation />
      {header?.children?.map((navigationItem) => {
        const isActive = navigationItem?._uid === activeItem?._uid;
        return (
          <NavigationItem
            key={navigationItem._uid}
            navigationItem={navigationItem}
            isActive={isActive}
            expandedAccordion={expandedAccordion}
            handleAccordionChange={handleAccordionChange}
          />
        );
      })}
    </div>
  );
};
